function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtboard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.89,
    height: 62.98647,
    viewBox: "0 0 57.89 62.98647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M55.88694,40.98804V21.98804c-.00247-3.74637-2.00233-7.20717-5.24699-9.08L34.18894,3.40804c-3.24675-1.87499-7.24725-1.87499-10.494,0L7.24393,12.90804c-3.24683,1.87408-5.24702,5.33813-5.24699,9.087v19c-.00003,3.74887,2.00017,7.21292,5.24699,9.087l16.451,9.5c3.24675,1.87498,7.24725,1.87498,10.494,0l16.451-9.5c3.24683-1.87408,5.24702-5.33813,5.24699-9.087",
    style: {
      fill: "#57ba8e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M55.89,40.98624V21.98624c-.00247-3.74637-2.00233-7.20717-5.24699-9.08L34.192,3.40624c-3.24675-1.87499-7.24725-1.87499-10.494,0L7.24699,12.90624c-3.24683,1.87408-5.24702,5.33813-5.24699,9.087v19c-.00003,3.74887,2.00017,7.21292,5.24699,9.087l16.451,9.5c3.24675,1.87498,7.24725,1.87498,10.494,0l16.451-9.5c3.24899-1.87533,5.24953-5.34262,5.24699-9.09399Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M22.14392,45.19003c-1.789-1.629-.8-4.217,2.14-5.75,.91996-.49342,1.95749-.72548,3-.671,.58835,.05758,1.16169,.2198,1.693,.479,0-5.781-.033-16.705-.033-22.073,.319,0,.543-.032,.99-.032v.831c-.00791,.21353,.0028,.42733,.032,.639,.319,2.013,.767,2.811,3,5.271,2.847,3.159,3.678,5.047,3.678,7.57-.032,2.364-2.108,7.411-2.556,7.219,.7431-1.71053,1.33112-3.48431,1.757-5.3,.21579-2.19844-.42505-4.39537-1.789-6.133-1.12472-1.13956-2.55649-1.92754-4.121-2.268,0,0-.032,11.628-.032,16.036-.13301,.90695-.49777,1.76424-1.059,2.489-1.752,2.109-5.17,3.067-6.7,1.693Z",
    style: {
      fill: "#178358"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard2);
export default __webpack_public_path__ + "static/media/Artboard_2.763d19634d720eee2c7e16d336883057.svg";
export { ForwardRef as ReactComponent };